import React from 'react'
import { StoreItem } from '../../data-types/data-types'
interface PI {
	data: StoreItem
}
const ProductCard = ({ data }: PI) => {
	return (
		<a href={data.redirect_url} rel="noreferrer" target="_blank" className='rounded focused text-slate-600 dark:text-slate-300 group shadow dark:shadow-md hover:shadow-lg transition-all duration-300'>
			<div className='h-32 w-full relative overflow-hidden'>
				<img src={data.image} className="h-full rounded-t w-full group-hover:scale-110 transition duration-300 object-cover" alt='itemImage' />
				<div className='flex text-white justify-center items-center px-1 text-xs bg-secondary absolute top-4 right-4 rounded-sm'>
					{data.sale_price &&
						<>
							-{(100 - ((Number(data.price) / Number(data.sale_price)) * 100)).toFixed(1)}%
						</>}
				</div>
			</div>
			<div className='py-5 px-3 flex flex-col h-32'>
				<h2 className='break-words text-black dark:text-white text-lg line-clamp-2'>{data.title}</h2>
				<div className='mt-auto'>
					<hr className='w-2/5 dark:border-slate-700 mb-1' />
					{data.sale_price && <small className='line-through mr-3'>&#8358;{data.sale_price}</small>}
					<span className='text-sm text-green-600'>&#8358;{data.price}</span>
				</div>
			</div>
		</a>
	)
}

export default ProductCard